module.exports = __webpack_public_path__ + "img/1.be2e9089.png";